export default "__VITE_ASSET__7edc1a76__"